
const headers = [
    {
      label: 'ชื่อหน่วยงานภาษาไทย / ชื่อหน่วยงานภาษาอังกฤษ',
      field: 'name',
    },
    {
      label: 'สถานะ',
      field: 'isActive',
    },
    {
      label: 'สถานะ Service',
      field: 'isService',
    },
    {
      label: 'แก้ไขข้อมูลล่าสุด',
      field: 'updateDate',
      tdClass: 'text-center',
    },
    {
      label: 'จัดการ',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers